import React from 'react';
import {Route} from 'react-router-dom';
import auth0Client from '../Auth';

function SecuredRoute(props) {
  //console.log('secure Route Called');
  const {component: Component, path, checkingSession, location} = props;
  return (
    <Route path={path} render={() => {
      if (checkingSession) return <h3 className="text-center">Validating session...</h3>;

        if (!auth0Client.isAuthenticated()) {
          console.log('No Authenticated URL: ' + location.pathname);
         localStorage.setItem('redirectloc', location.pathname);
          auth0Client.signIn();
          return <div>Not authenticated</div>;
        }
        let venueName = '';
        let base64Icon='';
        if(auth0Client.getDefaultVenue()){
          let defaultVenue = auth0Client.getDefaultVenue();
          venueName= defaultVenue.name;
          base64Icon= defaultVenue.base64Icon;
        }else{
          console.log('Default Venue not Set');
        }
        //console.log(location.pathname);
        return <Component {...props} venueName={venueName} base64Icon={base64Icon}/>
    }} />
  );
}

export default SecuredRoute;